import Vue from "vue";

const getDefaultState = () => {
	return {
		items: [],
		loaded: false,
		query: Object,
		activeItem: null,
		settings: null,
		calendars: null,
		users: null,
	};
};

const state = getDefaultState();

const actions = {
	reset({commit}) {
		commit("RESET");
	},
	getData({state, commit}, user) {
		commit("LOADING");
		return new Promise((resolve, reject) => {
			return http().get("calendar-events", {
				params: {
					user: user,
				},
			}).then(response => {
				commit("UPDATE_STATE", response);
				resolve();
			});
		});
	},
	activateModel({state, commit, dispatch}, {id}) {
		let found = _.find(state.items, function (item) {
			return item.id === id;
		});

		if (found) {
			commit("SET_ACTIVE_ITEM", found);

			return state.activeItem;
		}

		dispatch("getModel", {
			id: id,
		}).then(data => {
			commit("SET_ACTIVE_ITEM", data);
		});
	},
	getModel({state, commit}, {id}) {
		commit("SET_ACTIVE_ITEM", null);

		return new Promise((resolve, reject) => {
			http().get("calendar-events/" + id).then(response => {
				resolve(response.data.data);
			}).catch(error => {
				console.log(error);
			});
		});
	},
	addModel({state, commit, dispatch}, item) {
		if (!state.loaded) {
			return dispatch("getModels");
		}

		if ("string" !== typeof item) {
			return commit("ADD_ITEM", item);
		}

		return new Promise((resolve, reject) => {
			return http().get("calendar-events/" + item).then(response => {
				commit("ADD_ITEM", response.data.data);
				resolve();
			});
		});
	},
	updateModel({state, commit, dispatch}, item) {
		if (!state.loaded) {
			return dispatch("getModels");
		}

		let id = "string" === typeof item ? item : item.id;

		if (
			state.items.findIndex(item => item.id === id) < 0 &&
			state.activeItem.id !== id
		) {
			return;
		}

		if ("string" !== typeof item) {
			commit("UPDATE_ITEM", item);

			if (state.activeItem.id === item.id) {
				commit("SET_ACTIVE_ITEM", item);
			}

			return;
		}

		return new Promise((resolve, reject) => {
			return http().get("calendar-events/" + item).then(response => {
				commit("UPDATE_ITEM", response.data.data);

				if (state.activeItem.id === id) {
					commit("SET_ACTIVE_ITEM", response.data.data);
				}

				resolve();
			});
		});
	},
};

const mutations = {
	RESET(state) {
		Object.assign(state, getDefaultState());
	},
	LOADING(state) {
		state.loaded = false;
	},
	UPDATE_STATE(state, response) {
		state.items = Object.keys(response.data.data.models).map((key) => {
			return response.data.data.models[key];
		});
		state.calendars = response.data.calendars;
		state.settings = response.data.settings;
		state.users = response.data.users;
		state.loaded = true;
	},
	ADD_ITEM(state, payload) {
		state.items.unshift(payload);
	},
	UPDATE_ITEM(state, payload) {
		Vue.set(state.items, state.items.findIndex(i => i.id === payload.id), payload);
	},
	SET_ACTIVE_ITEM(state, payload) {
		state.activeItem = payload;
	},
};

const getters = {
	activeItem() {
		return state.activeItem;
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
